(function () {
  angular.module("akitabox.ui.components.floorInput", [
    "akitabox.core.services.floor",
    "akitabox.core.toast",
    "akitabox.core.utils",
    "akitabox.ui.components.typeAheadInput",
  ]);
})();
